import React from 'react';
import PropTypes from 'prop-types';
import { withStyles } from '@mui/styles';
import Card from '@mui/material/Card';
import CardContent from '@mui/material/CardContent';
import Typography from '@mui/material/Typography';
import Box from '@mui/material/Box';
import CircularProgress from '@mui/material/CircularProgress';

const styles = {
  card: {
    height: '100%',
    borderRadius: 12,
    boxShadow: '0 1px 3px rgba(15, 23, 42, 0.08), 0 1px 2px rgba(15, 23, 42, 0.04)',
    display: 'flex',
    flexDirection: 'column',
  },
  header: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    flexWrap: 'wrap',
    gap: 8,
    marginBottom: 8,
  },
  title: {
    fontWeight: 600,
    fontSize: '1rem',
    color: '#1e293b',
  },
  body: {
    flex: 1,
    minHeight: 260,
    position: 'relative',
  },
  loading: {
    position: 'absolute',
    inset: 0,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    background: 'rgba(255,255,255,0.6)',
    zIndex: 2,
  },
};

function DashboardCard({ classes, title, actions, loading, children, dense }) {
  return (
    <Card
      className={classes.card}
      sx={dense ? { height: 'auto' } : undefined}
    >
      <CardContent
        sx={{
          flex: dense ? 'none' : 1,
          display: 'flex',
          flexDirection: 'column',
          pb: dense ? '12px !important' : '16px !important',
          pt: dense ? 1.5 : undefined,
          px: dense ? 2 : undefined,
        }}
      >
        {title || actions ? (
          <Box className={classes.header} sx={dense ? { mb: 1 } : undefined}>
            {title ? <Typography className={classes.title}>{title}</Typography> : <span />}
            {actions ? <Box sx={{ display: 'flex', gap: 1, alignItems: 'center', flexWrap: 'wrap' }}>{actions}</Box> : null}
          </Box>
        ) : null}
        <Box
          className={classes.body}
          sx={dense ? { minHeight: '0 !important', flex: 'none' } : undefined}
        >
          {loading ? (
            <div className={classes.loading}>
              <CircularProgress size={32} />
            </div>
          ) : null}
          {children}
        </Box>
      </CardContent>
    </Card>
  );
}

DashboardCard.propTypes = {
  classes: PropTypes.object.isRequired,
  title: PropTypes.node,
  actions: PropTypes.node,
  loading: PropTypes.bool,
  children: PropTypes.node,
  dense: PropTypes.bool,
};

export default withStyles(styles)(DashboardCard);



// WEBPACK FOOTER //
// ./src/components/dashboard2/DashboardCard.js